export default "__VITE_ASSET__DNcLzlVE__"